import React from 'react';

export class Switch extends React.Component {
	state = {
		checked: this.props.value,
		disabled: false
	};

	enableSwitch = () => {
		this.setState({
			disabled: false
		});
	};

	disableSwitch = () => {
		this.setState({
			disabled: true
		});
	};

	handleOnChange = async () => {
		this.disableSwitch();
		this.setState({
			checked: !this.state.checked
		});
		if (this.props.onValueChange) {
			const valueUpdated = await this.props.onValueChange(!this.props.value);
			if (!valueUpdated) {
				this.setState({
					checked: !this.state.checked
				});
			}
		}
		this.enableSwitch();
	};

	static getDerivedStateFromProps = (props, state) => {
		const stateChanged = props.value !== state.checked && !state.disabled;
		const disabledPropsChanged =
			props.disabled !== undefined ? props.disabled !== state.disabled : false;
		if (stateChanged && !disabledPropsChanged) {
			const newState = {
				checked: props.value,
				disabled: state.disabled
			};
			return newState;
		}
		if (disabledPropsChanged) {
			const newState = {
				checked: state.value,
				disabled: props.disabled
			};
			return newState;
		}
		return state;
	};

	componentDidMount = () => {
		if (this.props.disabled) this.setState({ disabled: this.props.disabled });
	};

	render() {
		const hasTextLabels = Boolean(
			this.props.activeLabel && this.props.inactiveLabel
		);

		return (
			<div
				style={this.props.style || {}}
				className={`field switch-button ${this.props.className || ''}`}>
				<input
					id={'disable-' + this.props.id}
					checked={this.state.checked}
					disabled={this.state.disabled}
					onChange={this.handleOnChange}
					type="checkbox"
					tabIndex={hasTextLabels ? -1 : undefined}
					name="switchRoundedDefault"
					className="switch is-rounded"
					aria-hidden={hasTextLabels ? true : undefined}
				/>
				<label htmlFor={'disable-' + this.props.id} />
				{hasTextLabels ? (
					<button
						type="button"
						className="switch-label has-text-left"
						disabled={this.state.disabled}
						aria-pressed={this.state.checked}
						onClick={() => {
							if (!this.state.disabled) this.handleOnChange();
						}}>
						{this.state.checked
							? this.props.activeLabel
							: this.props.inactiveLabel}
					</button>
				) : null}
			</div>
		);
	}
}
